<section class="block_form">
    <div>
        <div class="row head_result">
            <div class="col-4 blue_item">
                <h1>Перейти в библиотеку</h1>
            </div>
            <!-- <div class="col-4 back_btn"><a class="cursor_pointer" (click)="goBack($event)">Назад</a></div>
            <div class="col-4 right"><button *ngIf="!outcome.current_user_library && authenticated" (click)="addToLibrary()" style="width: auto;" class="add_button open_accessadd add_tolib"><img src="/newpion/static/pionfront/assets/img/check_white.png"><span>Добавить в мою библиотеку</span></button></div> -->
        </div>
        <div class="container container-libs">
            <div class="row">
                <div class="col-12">
                    Материалы библиотеки разделены на четыре части: логические модели, социальные результаты, инструменты и кейсы.
                </div>
            </div>
            <div class="row">
                <div class="col-6 text-justify">
                    <p>
                        В Библиотеке логических моделей и деревьев результатов собраны файлы с логическими моделями и деревьями результатов программ, которые реализуют отечественные организации, работающие в сфере защиты детства.  Каждая программа сопровождается краткой справочной информацией: какая организация реализует(реализовала) программу, в какие сроки, с какими целевыми группами, на достижение каких социальных результатов ориентирована программа, проходила ли программа (практика) верификацию и какие уровни доказанности были присвоены.
                    </p>
                </div>
                <div class="col-6 text-justify">
                    <p>
                        В Библиотеку социальных результатов включены результаты, на достижение которых чаще всего ориентированы проекты и программы отечественных организаций, работающих в сфере защиты детства.   Для каждого социального результата указано: общая и частные формулировки, показатели, с помощью которых измеряется достижение социального результата, методы и инструменты, которые используются на практике для измерения показателей.  Познакомиться  с  заинтересовавшим инструментом, можно не выходя из библиотеки.
                    </p>
                </div>
                
            </div>
            <div class="row">
                <div class="col-6 text-justify">
                    <div (click)="goLibrary('library')" class="button cursor_pointer libbutton">
                        <button class="add_button br1">Библиотека логических моделей и деревьев результатов</button>
                    </div>
                </div>
                <div class="col-6 text-justify">
                    <div (click)="goLibrary('outcomes')" class="button cursor_pointer libbutton">
                        <button class="add_button br1">Библиотека социальных результатов</button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6 text-justify">
                    <p>
                        В Библиотеке инструментов собраны инструменты,  которые используют отечественные организации, работающие в сфере защиты детства, для измерения непосредственных и социальных результатов своих программ. Каждый инструмент сопровождается краткой справочной информацией: для какой целевой группы разработан инструмент (кто именно является источником информации),  для измерения какого уровня результатов  и в каких практиках может быть использован,  к какому методу сбора данных относится, имеются ли сведения о его стандартизации, ограничения  применения. 
                    </p>
                </div>
                <div class="col-6 text-justify">
                    <p>
                        В Библиотеку кейсов включены кейсы отечественных организаций, работающих в сфере защиты детства, которые активно развивают систему мониторинга и оценки. Из аннотации кейса можно узнать как о самой организации, так и об элементах системы мониторинга и оценки, представленных в  кейсе. Справочная информация об организации  содержит сведения об  ее целевых группах и типах практики, об основных социальных результатах, о том, проходила ли практика верификацию. К отдельным кейсам приложены отчеты об оценке.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-6 text-justify">
                    <div (click)="goLibrary('tools')" class="button cursor_pointer libbutton">
                        <button class="add_button br2">Библиотека инструментов</button>
                    </div>
                </div>
                <div class="col-6 text-justify">
                    <div (click)="goLibrary('cases')" class="button cursor_pointer libbutton">
                        <button class="add_button br2">Библиотека кейсов</button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <p>
                        В каждом разделе можно настроить систему поиска по категориям и подкатегориям.
                    </p>
                    <p *ngIf="!auth">
                        Скачивать файлы и создавать личные библиотеки могут только зарегистрированные пользователи. <a routerLink="/auth/login">Войдите</a> или <a routerLink="/auth/registration">зарегистрируйтесь</a>.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>